import { createContext } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/context/context-key.js';
export const personalizedContentContext = createContext('personalization-wrapper');
//# sourceMappingURL=interfaces.js.map